<template>
  <div style="position:relative">
    <div
      class="intl-tel-input allow-dropdown separate-dial-code iti-sdc-2"
      :class="{'has-error' : invalid}"
      style="font-size:14px"
    >
      <div class="flag-container">
        <div
          class="selected-flag"
          role="combobox"
          aria-owns="country-listbox"
          tabindex="0"
          title="United States: +1"
          @click="openCheckbox()"
        >
          <div
            class="iti-flag "
            v-bind:class="activeCountry.iso2.toLowerCase()"
          ></div>
          <div class="selected-dial-code">{{ activeCountry.dialCode }}</div>
          <div class="iti-arrow"></div>
        </div>
      </div>
      <ul class="country-list" v-show="visible">
        <li
          class="country preferred active"
          v-bind:class="'item-' + defaultCountry.iso2.toLowerCase()"
          role="option"
        >
          <div class="flag-box" @click="choose(defaultCountry)">
            <div
              class="iti-flag "
              v-bind:class="defaultCountry.iso2.toLowerCase()"
            ></div>
          </div>
          <span class="country-name" @click="choose(defaultCountry)">{{
            defaultCountry.name
          }}</span>
          <span class="dial-code" @click="choose(defaultCountry)">{{
            defaultCountry.dialCode
          }}</span>
        </li>
        <li
          class="divider"
          style="border-bottom: 1px solid #CCC !important"
        ></li>
        <li
          v-for="pb in allCountries"
          :key="pb['iso2']"
          @click="choose(pb)"
          class="country preferred active"
          v-bind:class="'item-' + pb.iso2.toLowerCase()"
          role="option"
        >
          <div class="flag-box" @click="choose(pb)">
            <div class="iti-flag " v-bind:class="pb.iso2.toLowerCase()"></div>
          </div>
          <span class="country-name" @click="choose(pb)">{{ pb.name }}</span>
          <span class="dial-code" @click="choose(pb)">{{ pb.dialCode }}</span>
        </li>
      </ul>
      <input
      name="phone"
        type="tel"
        class="form-control phone-field"
        :class="{'invalid': invalid }"
        :value="phoneModel"
        @input="onInput($event.target.value)"
        @blur="validate"
        v-validate.continues="validationRules"
        placeholder="Enter your phone number"
      />
      <div class="input-overlay">
      <i v-if="invalid" class="fa fa-warning is-danger"></i>
    </div>
    </div>
    
    <!-- <div class='group-item'>
        <div class='flag-item' v-on:click='openCheckbox'>
             <img :src="activeCountry.icon" class='flag-img' width="20px"/> <i class="fa fa-sort-desc" style="font-size: 11px;" aria-hidden="true"></i>
        </div>
         <input type='tel' :value="phoneModel" @input='onInput($event.target.value)' placeholder="Enter your phone number" style='border: none;width: 50%;' />
    </div>

    <div class='dropdown' v-show="visible">
        <div class='dropdown-item' v-for="pb in allCountries"  :key="pb['iso2']"  @click="choose(pb)">
            <img :src="pb.icon" width="20px"/>
            <strong>{{ pb.name }}</strong>
            <span> {{ pb.dialCode }} </span>
        </div>
    </div> -->
  </div>
</template>

<script>
// import { parseNumber, formatNumber, AsYouType } from 'libphonenumber-js'
import { parseNumber, AsYouType } from 'libphonenumber-js'
import allCountries from '../assets/all-countries'
// import getCountry from '../assets/default-country'

export default {
  name: 'vue-tel-input',
  props: ['phone', 'validationRules', 'invalid'],
  data () {
    return {
      allCountries,
      activeCountry: allCountries[0],
      defaultCountry: allCountries.find((country) => country.iso2 === 'US'),
      visible: false,
      phoneModel: null
    }
  },
  created () {
    window.addEventListener(
      'keypress',
      function (e) {
        this.searchButton(e)
      }.bind(this)
    )
  },
  watch: {
    phone (phone) {
      this.proccessValue(phone)
      if (this.$validator) {
        this.validate()
      }
    },
    activeCountry () {
      this.validate()
    }
  },
  computed: {
    countruCode () {
      return this.activeCountry.iso2
    },
    fullPhone () {
      return this.countruCode + this.phoneModel
    }
  },
  mounted () {
    this.activeCountry = this.defaultCountry
    this.proccessValue(this.phone)
  },
  methods: {
    proccessValue (phone) {
      if (!phone) {
        this.phoneModel = ''
      } else {
        if (phone && phone[0] === '+') {
        // if user manually type the country code
        const formatter = new AsYouType(); // eslint-disable-line
          formatter.input(phone)
          this.activeCountry =
          this.allCountries.find(
            (ele) => ele.iso2.toUpperCase() === formatter.country
          ) || this.activeCountry; // eslint-disable-line
          this.phoneModel = phone.replace(this.activeCountry.dialCode, '')
        }
      }
    },
    validateFn (value, country) {
      let pNumber = parseNumber(value, this.activeCountry.iso2)
      let valid = !(Object.keys(pNumber).length === 0 &&
          pNumber.constructor === Object)
      return valid
    },
    choose (country) {
      this.visible = false
      this.activeCountry = country
      this.phoneModel = ''
      this.validate()
    },
    openCheckbox () {
      this.visible = !this.visible
    },
    onInput (phoneNum) {
      this.phoneModel = phoneNum
      if (phoneNum) {
        let phone = this.parsePhone(phoneNum)
        if (phone) {
          this.phoneModel = phone
        }
      }
      this.validate()
    },
    validate () {
      this.$validator.validate().then((valid) => {
        if (valid || !this.phoneModel) {
          this.$emit('input', this.phoneModel ? this.activeCountry.dialCode + this.phoneModel : null)
        }
        this.$emit('onValidate', valid)
      })
    },
    parsePhone (value) {
      if (!value) {
        return
      }
      if (value && value[0] === '+') {
        // if user manually type the country code
        const formatter = new AsYouType(); // eslint-disable-line
        formatter.input(value)
        this.activeCountry =
          this.allCountries.find(
            (ele) => ele.iso2.toUpperCase() === formatter.country
          ) || this.activeCountry; // eslint-disable-line
        value = value.replace(this.activeCountry.dialCode, '')
      }
      let parsed = parseNumber(value, this.activeCountry.iso2)
      return parsed.phone
    },
    searchButton (event) {
      for (var i = 0; i < this.allCountries.length; i++) {
        if (this.startsWith(this.allCountries[i].name, event.key)) {
          var className = 'item-' + this.allCountries[i].iso2.toLowerCase()
          var elem = document.getElementsByClassName(className)[0]
          this._scrollTo(elem, true)
          break
        }
      }
    },
    _scrollTo (element, middle) {
      var containers = document.getElementsByClassName('country-list')
      for (var i = 0; i < containers.length; i++) {
        var cont = containers[i]
        var windowTop =
          window.pageYOffset || document.documentElement.scrollTop
        var containerHeight = cont.offsetHeight
        var containerTop = cont.getBoundingClientRect().top + windowTop
        var containerBottom = containerTop + containerHeight
        var elementHeight = element.offsetHeight
        var elementTop = element.getBoundingClientRect().top + windowTop
        var elementBottom = elementTop + elementHeight
        var newScrollTop = elementTop - containerTop + cont.scrollTop
        var middleOffset = containerHeight / 2 - elementHeight / 2
        if (elementTop < containerTop) {
          // scroll up
          if (middle) newScrollTop -= middleOffset
          cont.scrollTop = newScrollTop
        } else if (elementBottom > containerBottom) {
          // scroll down
          if (middle) newScrollTop += middleOffset
          var heightDifference = containerHeight - elementHeight
          cont.scrollTop = newScrollTop - heightDifference
        }
      }
    },
    startsWith (a, b) {
      return a.substr(0, b.length).toLowerCase() === b
    }
  }
}
</script>
<style scoped>
.intl-tel-input{
  position: relative;
}

.intl-tel-input.has-error input{
  padding-right: 32px;
}

.intl-tel-input input{
  z-index: 1;
}

.flag-container{
  z-index: 2;
}

.input-overlay{
  height: inherit;
  position: absolute;
  inset: 0;
  width: 100%;
}

.input-overlay > i {
  font-size: 20px;
  color: darkgray;
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  z-index: 1;
}

</style>



// WEBPACK FOOTER //
// tel-input.vue?5571edce